// Frittstående kapabilitetsplanlegger-vindu (poppet ut). Leser/skriver via
// /kapabilitet* (sesjons-cookie, hubben håndhever RBAC og org-scope server-
// side) — samme mønster som personregister-panel.ts.
//
// ⚠ INGEN KARTKLIKK-PLASSERING HER. Et poppet-ut vindu deler ikke CopMap-
// instansen (egen `window`, egen prosess i praksis) — `armPlassering`/
// `tegnRinger`/`flyTo` er alle valgfrie hooks i panelet og utelates derfor
// bevisst. Operatøren har fortsatt manuelt koordinat + «anbefal»/bestilling —
// bare ikke klikk-i-kartet fra dette vinduet. Full funksjon: bruk hoved-COP.
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { KapabilitetsplanleggerPanel, kapabilitetHent, kapabilitetSend } from '../ui/kapabilitetsplanlegger.js';

export function mountKapabilitetsplanleggerPanel(root: HTMLElement, _feed: Feed, _sync: SyncBus, _user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const panel = new KapabilitetsplanleggerPanel({
    hent: kapabilitetHent,
    send: kapabilitetSend,
    naa: () => Date.now(),
    tegnRinger: () => {},
  });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
}
